import * as React from 'react';
import { GlobalEventManagerContext } from './global-events.context';
import { EventManager } from '../event-manager';
import { currentWindow } from '../env';

export function GlobalEventsProvider(props: { children: JSX.Element }) {
    const eventManager = React.useMemo(() => new EventManager(), []);
    const _onClickHandler = React.useCallback((eventArgs: MouseEvent) => eventManager.emit('windowClick', eventArgs), [eventManager]);
    const _onResizeHandler = React.useCallback((eventArgs: UIEvent) => eventManager.emit('windowResize', eventArgs), [eventManager]);

    React.useEffect(() => {
        currentWindow.addEventListener('click', _onClickHandler);
        currentWindow.addEventListener('resize', _onResizeHandler);
        return () => {
            currentWindow.removeEventListener('click', _onClickHandler);
            currentWindow.removeEventListener('resize', _onResizeHandler);
        };
    }, [_onClickHandler, _onResizeHandler]);

    return (
        <GlobalEventManagerContext.Provider value={eventManager}>
            {props.children}
        </GlobalEventManagerContext.Provider>
    );
}
